import { render, staticRenderFns } from "./LinkObject.vue?vue&type=template&id=439afe40&scoped=true"
import script from "./LinkObject.vue?vue&type=script&lang=js"
export * from "./LinkObject.vue?vue&type=script&lang=js"
import style0 from "./LinkObject.vue?vue&type=style&index=0&id=439afe40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439afe40",
  null
  
)

export default component.exports